import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function StatCard({ label, value, sub, icon: Icon, accent = "#007AFF", trend, testid }) {
  return (
    <div
      data-testid={testid}
      className="relative bg-[#0f0f0f] border border-white/5 rounded-xl p-5 overflow-hidden group hover:border-white/10 transition-colors duration-200"
      style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)" }}
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-semibold uppercase tracking-[0.15em] text-[#8a8a8a]">{label}</span>
        {Icon && (
          <div
            className="h-8 w-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${accent}1a`, color: accent }}
          >
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 font-head text-2xl md:text-3xl font-bold tracking-tight text-white tnum">
        {value}
      </div>
      {sub != null && (
        <div className="mt-1.5 flex items-center gap-1 text-xs">
          {trend != null && (
            <span className={trend >= 0 ? "text-[#10B981] flex items-center" : "text-[#EF4444] flex items-center"}>
              {trend >= 0 ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
              {Math.abs(trend)}%
            </span>
          )}
          <span className="text-[#666]">{sub}</span>
        </div>
      )}
    </div>
  );
}
